export { default } from './TypographyLongForm'
export * from './TypographyLongForm'
